import { GetServerSideProps } from "next";
import { Locale } from "../../lib/types";
import api from "../../lib/utils/api";
import { mapAboutPageData } from "../../lib/utils/mappers";
import { Col, Container, Row } from 'react-bootstrap';
import Featurette from '../../components/Featurette';
import { FEATURETTE_IMAGE_PLACEMENTS } from '../../lib/constants';
import { RichText } from '../../components/RichText';
import cmsEndpoints from "../../lib/utils/cmsEndpoints";
import { PageHead } from "../../components/PageHead";

export const getServerSideProps: GetServerSideProps = async (context) => {
  context.res.setHeader(
    'Cache-Control',
    'public, s-maxage=10, stale-while-revalidate=59'
  )

  const locale = context.locale as Locale

  const pageData = await api.get(cmsEndpoints.aboutPage())

  const page = mapAboutPageData(pageData?.data?.data?.attributes, locale)

  return {
    props: {
      page
    }
  }
}

const About = (props: any) => {

  return(
    <>
      <PageHead title={props.page?.title} image={props.page.image} />
      <div className="bg-light">
      <Featurette image={props.page.image} imagePlacement={FEATURETTE_IMAGE_PLACEMENTS.RIGHT} backgroundColor='#F8FBFC' mobileFullscreenImage={true}>
        {props.page?.title && <h3 className='mb-3'> {props.page?.title} </h3>}
        {props.page?.quote && <h4 className='display-6 text-dark fw-normal fs-2 mb-3'> {props.page?.quote} </h4>}
        {props.page?.quoteSource && <h5 className='fw-light'> {props.page?.quoteSource} </h5>}
      </Featurette>
      </div>
      <Container>
          <Row className="py-5 mb-5 justify-content-center">
            <Col md="8">
              {props.page?.content && <RichText content={props.page?.content}/> }
            </Col>
          </Row>
      </Container>
    </>
  )
}

export default About
